import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';
import * as common from 'libs/commonFunc';

import { Icon, Progress, Dropdown, Image } from 'semantic-ui-react';
import { IconButton, Tooltip } from 'material-ui';

import * as commonVar from 'libs/commonVar';

import styles from './ExamSummaryItem.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamSummaryItem extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { exam, isOpen, selected, groupClass } = this.props;
    // function
    const {
      onSelectExamSummary,
      // 선택한 영역으로 필터가 선택
      onSelectEachInfo,
      onToggleExamSummary,
      onExamToggleModal,
      onExamPause
    } = this.props;
    const { templateData, initTemplates } = this.props;
    const {
      examNo,
      examName,
      examType,
      examStartEpoch,
      examEndEpoch,
      target,
      send,
      read,
      download,
      fileDown,
      linkAttach,
      fileInfection,
      infection,
      phishing,
      connect,
      isSuspend,
      serviceTemplateNo,
      templateName,
      templatePick,
      sendError,
      parentsExamNo,
      parentExamCount
    } = exam.toJS();
    // 현재 진행상태
    let progress = 1;
    // 훈련 즉시 실행 (예약 훈련)
    let isReserveExam = false;
    // 훈련 즉시 종료
    let isEndActive = false;

    if (examStartEpoch > common.nowEpoch()) {
      progress = 0;
      isReserveExam = true;
    } else {
      // 훈련 진행중
      // progress = Math.round(
      //   (common.nowEpoch() - common.epochFromDate(common.timeFormatFromUTCEpoch(examStartEpoch, 3))) /
      //     (common.epochFromDate(common.timeFormatFromUTCEpoch(examEndEpoch, 3)) -
      //       common.epochFromDate(common.timeFormatFromUTCEpoch(examStartEpoch, 3))) *
      //     100
      // );
      progress = Math.round((common.nowEpoch() - examStartEpoch) / (examEndEpoch - examStartEpoch) * 100);

      // 만약 훈련 진행중인데 1%가 안되어도 1%로 표기
      progress = 1 > progress ? 1 : progress;
      isEndActive = true;
    }
    if (progress > 100) {
      progress = 100;
    }
    if (progress === 100) {
      isEndActive = false;
    }

    // 메일 발송 일시정지 체크
    let isSendPause = false;
    if (!!isEndActive && target > send + sendError) {
      isSendPause = true;
    }

    let SendTitle = '';
    if (isSuspend === 1) {
      SendTitle += defineMessages(formatMessage({ id: 'ExamSummaryItem_16', defaultMessage: '메일 발송 일시정지' }));
    }
    if (!!sendError) {
      if (SendTitle !== '') {
        SendTitle += ' / ';
      }
      SendTitle +=
        defineMessages(formatMessage({ id: 'ExamListItem_20', defaultMessage: '발송 실패' })) +
        ': ' +
        sendError +
        defineMessages(formatMessage({ id: 'ExamListItem_10', defaultMessage: '개' }));
    }
    if (SendTitle !== '') {
      SendTitle = ' - ' + SendTitle;
    }

    const isPhishing = 4 === examType ? true : false;

    // 훈련 리스트 - 카테고리 템플릿 아이콘
    let catempImg = '';
    if (1 === examType && 1 === exam.getIn(['attachData', 'attachExamType'])) {
      catempImg = 'cate_warning.png';
    } else if (1 === examType && 2 === exam.getIn(['attachData', 'attachExamType'])) {
      catempImg = 'cate_file.png';
    } else if (1 === examType && 3 === exam.getIn(['attachData', 'attachExamType'])) {
      catempImg = 'cate_research.png';
    } else if (4 === examType) {
      catempImg = 'cate_phishing.png';
    }

    if (!!parentsExamNo) {
      let groupLevel = '';
      if (!!parentsExamNo === examNo) {
        groupLevel = 'parents';
      } else {
        groupLevel = 'children';
      }
    }

    return (
      <div
        className={cx(
          'examSummaryItem-wrapper',
          'bt-open',
          { selected: selected },
          { group: parentsExamNo },
          groupClass
        )}
        onClick={() => onSelectExamSummary(examNo, examType)}>
        {/* {parentsExamNo && <div className={cx('group-background')} />} */}

        <div className={cx('item-wrapper')}>
          <div className={cx('item-inner')}>
            <div className={cx('examName-wrap')}>
              {/* 훈련명 */}
              <div className={cx('examName')}>
                {/* 감염이 있을경우 아이콘 표시 */}
                {infection > 0 && (
                  <Tooltip
                    title={
                      4 === examType
                        ? defineMessages(formatMessage({ id: 'ExamSummaryItem_21', defaultMessage: '정보 유출 있음' }))
                        : defineMessages(formatMessage({ id: 'ExamSummaryItem_5', defaultMessage: '감염 대상 있음' }))
                    }
                    placement="top">
                    {4 === examType ? (
                      <Image className={cx('mr-5 castop-icon')} src="/img/exam/cate_phishing_red.png" />
                    ) : (
                        <Image className={cx('mr-5 castop-icon')} src="/img/exam/cate_infection_red.png" />
                      )}
                  </Tooltip>
                )}
                {/* 메일 발송 일시 정지 */}
                {isSuspend === 1 && (
                  <Tooltip
                    title={defineMessages(
                      formatMessage({ id: 'ExamSummaryItem_16', defaultMessage: '메일 발송 일시정지' })
                    )}
                    classes={{ tooltip: 'tooltip-noMaxWidth' }}
                    placement="top">
                    <Image className={cx('mr-5 castop-icon')} src="/img/exam/cate_stop.png" />
                  </Tooltip>
                )}
                {/* 예약 훈련 표시 */}
                {isReserveExam && (
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'ExamSummary_10', defaultMessage: '예약 훈련' }))}
                    classes={{ tooltip: 'tooltip-noMaxWidth' }}
                    placement="top">
                    <Image className={cx('mr-5 castop-icon')} src="/img/exam/cate_reserve.png" />
                  </Tooltip>
                )}
                {!!parentsExamNo && <span className={cx('examGroup-number')}>{parentExamCount}</span>}
                <div className={cx('examName-text')}>{examName}</div>
                <div className={cx('examSummary-bt-area')}>
                  {/* 수정, 삭제 버튼 */}
                  <Dropdown
                    floating
                    pointing="top right"
                    button
                    className="icon"
                    icon={<Image className={cx('ui image')} src="/img/exam/cate_setting.png" />}
                    className={cx('examSummary-dropdown')}>
                    <Dropdown.Menu>
                      {0 < progress &&
                        progress < 100 && (
                          <Dropdown.Item
                            icon="write"
                            text={defineMessages(formatMessage({ id: 'ExamSummaryItem_1', defaultMessage: '수정' }))}
                            onClick={() => onExamToggleModal(examNo, 'examEdit')}
                          />
                        )}
                      <Dropdown.Item
                        icon="trash"
                        text={defineMessages(formatMessage({ id: 'ExamSummaryItem_2', defaultMessage: '삭제' }))}
                        onClick={() => onExamToggleModal(examNo, 'examDelete')}
                      />
                      {!!isSendPause &&
                        isSuspend === 0 && (
                          <Dropdown.Item
                            icon="pause circle outline"
                            text={defineMessages(
                              formatMessage({ id: 'ExamSummaryItem_16', defaultMessage: '메일 발송 일시정지' })
                            )}
                            onClick={() => onExamPause(examNo, 1)}
                          />
                        )}
                      {!!isSendPause &&
                        isSuspend === 1 && (
                          <Dropdown.Item
                            icon="video play outline"
                            text={defineMessages(
                              formatMessage({ id: 'ExamSummaryItem_17', defaultMessage: '메일 발송 재시작' })
                            )}
                            onClick={() => onExamPause(examNo, 0)}
                          />
                        )}
                      {!!isReserveExam && (
                        <Dropdown.Item
                          icon="video play outline"
                          text={defineMessages(
                            formatMessage({ id: 'ExamSummaryItem_3', defaultMessage: '훈련 즉시 실행' })
                          )}
                          onClick={() => onExamToggleModal(examNo, 'isStartNow')}
                        />
                      )}
                      {!!isEndActive && (
                        <Dropdown.Item
                          icon="stop circle outline"
                          text={defineMessages(
                            formatMessage({ id: 'ExamSummaryItem_4', defaultMessage: '훈련 즉시 종료' })
                          )}
                          onClick={() => onExamToggleModal(examNo, 'isEndNow')}
                        />
                      )}
                      {0 < progress &&
                        progress < 100 &&
                        !(!!isSendPause && isSuspend === 1) && (
                          <Dropdown.Item
                            icon="send"
                            text={defineMessages(
                              formatMessage({ id: 'ExamSummaryItem_22', defaultMessage: '훈련메일 재전송' })
                            )}
                            onClick={() => onExamToggleModal(examNo, 'examResend')}
                          />
                        )}
                      {0 < progress &&
                        progress < 100 &&
                        !(!!isSendPause && isSuspend === 1) && (
                          <Dropdown.Item
                            icon="send"
                            text={defineMessages(
                              formatMessage({ id: 'ExamSummaryItem_23', defaultMessage: '실패한 메일 재전송' })
                            )}
                            onClick={() => onExamToggleModal(examNo, 'failTargetExamResend')}
                          />
                        )}
                      {/* <Dropdown.Divider /> */}
                    </Dropdown.Menu>
                  </Dropdown>
                  <IconButton
                    className={cx('bt-toggleView')}
                    onClick={e => {
                      e.stopPropagation();
                      onToggleExamSummary(examNo);
                    }}>
                    {/* <Icon name={isOpen ? 'chevron up' : 'chevron down'} size="mini" /> */}
                    <Image src={isOpen ? '/img/exam/cate_close.png' : '/img/exam/cate_open.png'} />
                  </IconButton>
                </div>
              </div>
            </div>
            {isOpen && (
              <div className={cx('examDetail')}>
                {/* 훈련 기간 */}
                <div className={cx('examDetail-info', !!parentsExamNo ? 'groupDetail-background' : '')}>
                  <div className={cx('scanDate')}>
                    <span className={cx('title')}>
                      {defineMessages(formatMessage({ id: 'ExamSummaryItem_6', defaultMessage: '기간' }))}
                    </span>
                    <span className={cx('content')}>
                      {common.timeFormatFromUTCEpoch(examStartEpoch, 3)} ~{' '}
                      {common.timeFormatFromUTCEpoch(examEndEpoch, 3)}
                    </span>
                  </div>
                  <Tooltip
                    title={
                      <div>
                        <div>
                          {templatePick
                            ? defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' }))
                            : defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' }))}
                          {' / '}
                          {(1 === examType &&
                            1 === exam.getIn(['attachData', 'attachExamType']) &&
                            defineMessages(formatMessage({ id: 'ExamDetail_49', defaultMessage: '경고 안내' }))) ||
                            (1 === examType &&
                              2 === exam.getIn(['attachData', 'attachExamType']) &&
                              defineMessages(
                                formatMessage({ id: 'ExamDetail_50', defaultMessage: '모의 악성파일' })
                              )) ||
                            (1 === examType &&
                              3 === exam.getIn(['attachData', 'attachExamType']) &&
                              defineMessages(
                                formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' })
                              )) ||
                            (4 === examType &&
                              defineMessages(
                                formatMessage({ id: 'ExamTemplateList_16', defaultMessage: '피싱 유도' })
                              ))}
                          {' / '}
                          {1 === linkAttach &&
                            defineMessages(formatMessage({ id: 'ExamTemplateList_29', defaultMessage: '첨부 파일' }))}
                          {2 === linkAttach &&
                            defineMessages(formatMessage({ id: 'ExamTemplateList_28', defaultMessage: '링크 첨부' }))}
                          {3 === linkAttach &&
                            defineMessages(formatMessage({ id: 'ExamTemplateList_31', defaultMessage: '링크 + 첨부' }))}
                        </div>
                        <div>/ {templateName}</div>
                      </div>
                    }
                    placement="bottom">
                    <div className={cx('template-area')}>
                      <span className={cx('title')}>
                        {defineMessages(formatMessage({ id: 'ExamSummaryItem_7', defaultMessage: '템플릿' }))}
                      </span>
                      <span className={cx('content', 'ellipsis')}>
                        {/* <Icon name={templatePick === 1 ? 'user' : 'settings'} /> */}
                        {/* <Image className={cx('catemp-icon')} src={'/img/exam/' + catempImg} /> */}
                        {templateName}
                      </span>
                    </div>
                  </Tooltip>
                </div>
                <div className={cx('eachInfo-area-wrap')}>
                  <div className={cx('eachInfo-area')}>
                    <div className={cx('infoText')}>
                      {defineMessages(formatMessage({ id: 'ExamSummaryItem_8', defaultMessage: '훈련 대상' }))}
                    </div>
                    <div className={cx('infoCount', 'target')}>{target}</div>
                  </div>
                  <Tooltip
                    title={
                      defineMessages(
                        formatMessage({ id: 'ExamSummaryItem_9', defaultMessage: '메일이 발송된 대상만 보기' })
                      ) + SendTitle
                    }
                    placement="bottom">
                    <div
                      className={cx('eachInfo-area', { 'color-red': !!sendError }, { 'color-orange': isSuspend === 1 })}
                      // title={SendTitle}
                      onClick={e => {
                        e.stopPropagation();
                        onSelectEachInfo(examNo, 'send');
                      }}>
                      <div className={cx('infoText display-flex')}>
                        {defineMessages(formatMessage({ id: 'ExamSummaryItem_10', defaultMessage: '메일 발송' }))}
                        {isSuspend === 1 && <Icon name="pause circle outline" color="orange" />}
                        {/* 진행중 */}
                        {send + sendError < target &&
                          send + sendError !== 0 && (
                            <div className={cx('sendStatus')}>
                              <span className={cx('sendStatusText', { 'mr-5': commonVar.isJapan !== 1 })}>
                                {' (' +
                                  defineMessages(formatMessage({ id: 'ExamHeader_21', defaultMessage: '진행중' }))}
                              </span>
                              <span className={cx('sendStatusText')}>
                                {send === 0 ? '0%)' : (send / target * 100).toFixed(0) + '%)'}
                              </span>
                            </div>
                          )}
                      </div>
                      <div className={cx('cover-area')}>
                        <Icon name="arrow right" size="tiny" />
                      </div>
                      <div className={cx('infoCount', 'send')}>
                        {!!sendError && <Icon name="warning" size="tiny" className={cx('color-red')} />}
                        {send}
                      </div>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title={defineMessages(
                      formatMessage({ id: 'ExamSummaryItem_11', defaultMessage: '메일을 열람한 대상만 보기' })
                    )}
                    placement="bottom">
                    <div
                      className={cx('eachInfo-area', { 'color-orange': read })}
                      onClick={e => {
                        e.stopPropagation();
                        onSelectEachInfo(examNo, 'read');
                      }}>
                      <div className={cx('infoText')}>
                        {defineMessages(formatMessage({ id: 'ExamSummaryItem_12', defaultMessage: '메일 열람' }))}
                      </div>
                      <div className={cx('cover-area')}>
                        <Icon name="arrow right" size="tiny" />
                      </div>
                      <div className={cx('infoCount', 'read')}>{read}</div>
                    </div>
                  </Tooltip>
                  {(2 & exam.get('linkAttach') || isPhishing) && (
                    <Tooltip
                      title={
                        // 피싱 유도
                        isPhishing
                          ? defineMessages(
                            formatMessage({
                              id: 'ExamSummaryItem_19',
                              defaultMessage: '피싱 페이지에 접속한 대상 보기'
                            })
                          )
                          : defineMessages(
                            formatMessage({
                              id: 'ExamSummaryItem_15',
                              defaultMessage: '파일을 다운로드한 대상만 보기'
                            })
                          )
                      }
                      placement="bottom">
                      <div
                        className={cx('eachInfo-area', { 'color-down': exam.get('download') })}
                        onClick={e => {
                          e.stopPropagation();
                          {
                            isPhishing ? onSelectEachInfo(examNo, 'connect') : onSelectEachInfo(examNo, 'fileDown');
                          }
                        }}>
                        <div className={cx('infoText')}>
                          {isPhishing
                            ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
                            : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                        </div>
                        <div className={cx('cover-area')}>
                          <Icon name="arrow right" size="tiny" />
                        </div>
                        <div className={cx('infoCount', 'download')}>{exam.get('download')}</div>
                      </div>
                    </Tooltip>
                  )}
                  <Tooltip
                    title={
                      // 피싱 유도
                      isPhishing
                        ? defineMessages(
                          formatMessage({
                            id: 'ExamSummaryItem_20',
                            defaultMessage: '정보 유출한 대상 보기'
                          })
                        )
                        : defineMessages(
                          formatMessage({
                            id: 'ExamSummaryItem_13',
                            defaultMessage: '메일의 첨부파일을 실행(감염)한 대상만 보기'
                          })
                        )
                    }
                    placement="bottom">
                    <div
                      className={cx('eachInfo-area', { 'color-red': infection })}
                      onClick={e => {
                        e.stopPropagation();
                        {
                          isPhishing ? onSelectEachInfo(examNo, 'phishing') : onSelectEachInfo(examNo, 'fileInfection');
                        }
                      }}>
                      <div className={cx('infoText')}>
                        {/* 피싱 유도 */}
                        {isPhishing
                          ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
                          : defineMessages(formatMessage({ id: 'ExamSummaryItem_14', defaultMessage: '감염' }))}
                      </div>
                      <div className={cx('cover-area')}>
                        <Icon name="arrow right" size="tiny" />
                      </div>
                      <div className={cx('infoCount', 'infection')}>{infection}</div>
                    </div>
                  </Tooltip>
                  {/* 모의 악성파일 */}
                  {1 === examType &&
                    2 === exam.getIn(['attachData', 'attachExamType']) && (
                      <Tooltip
                        title={defineMessages(
                          formatMessage({ id: 'ExamSummaryItem_18', defaultMessage: '악성파일을 치료한 대상 보기' })
                        )}
                        placement="bottom">
                        <div
                          className={cx('eachInfo-area', { 'color-cure': exam.get('cure') })}
                          onClick={e => {
                            e.stopPropagation();
                            onSelectEachInfo(examNo, 'cure');
                          }}>
                          <div className={cx('infoText')}>
                            {defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' }))}
                          </div>
                          <div className={cx('cover-area')}>
                            <Icon name="arrow right" size="tiny" />
                          </div>
                          <div className={cx('infoCount', 'cure')}>{exam.get('cure')}</div>
                        </div>
                      </Tooltip>
                    )}
                </div>
              </div>
            )}
            <Tooltip
              title={
                isReserveExam
                  ? defineMessages(formatMessage({ id: 'ExamSummary_10', defaultMessage: '예약 훈련' }))
                  : defineMessages(formatMessage({ id: 'ExamDetail_34', defaultMessage: '진행률' })) +
                  ': ' +
                  progress +
                  '%'
              }
              placement="bottom">
              {/* 퍼센트가 10~15%일때 공간이 좁아서 일부러 넓여준다 */}
              <div className={cx('progress-area', { expansionBar: progress > 9 && progress < 16 })}>
                <Progress
                  percent={progress}
                  size={!isOpen ? 'tiny' : 'medium'}
                  progress={isOpen}
                  inverted
                  indicating={isReserveExam ? false : true}
                  disabled={isReserveExam ? true : false}
                />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
}

ExamSummaryItem.propTypes = {
  exam: ImmutablePropTypes.mapContains({
    examNo: PropTypes.number,
    examName: PropTypes.string,
    examStartEpoch: PropTypes.number,
    examEndEpoch: PropTypes.number,
    target: PropTypes.number,
    read: PropTypes.number,
    download: PropTypes.number,
    fileDown: PropTypes.number,
    cure: PropTypes.number,
    fileInfection: PropTypes.number,
    infection: PropTypes.number,
    connect: PropTypes.number,
    phishing: PropTypes.number,
    attach: PropTypes.number,
    linkAttach: PropTypes.number,
    examType: PropTypes.number,
    attachScreenType: PropTypes.number
  }),
  isOpen: PropTypes.bool,
  onSelectExamSummary: PropTypes.func,
  onToggleExamSummary: PropTypes.func
};

export default injectIntl(ExamSummaryItem);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamSummaryItem.js